import { useContext } from 'react';
import { BookingLocationContext } from './BookingLocationContext';
import { useAuth } from './useAuth';
import { useMarketplace } from './useMarketplace';

export const useTimeZone = (): string => {
    const auth = useAuth();
    const marketplace = useMarketplace();
    const bookingLocation = useContext(BookingLocationContext);

    if (bookingLocation) {
        return bookingLocation.timeZone;
    }

    return marketplace?.schedule.timeZone || auth.timeZone!;
};

export default useTimeZone;
